import styled from 'styled-components';

export const IonWrapper = styled.div`
  .img-container {
    width: 100px;
    height: 100px;
    overflow: hidden;

    img,
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    ion-spinner {
      position: absolute;
      right: 0;
    }
  }
`;
